import { render, staticRenderFns } from "./TeleMarketAssignConfig.vue?vue&type=template&id=ef5ecd44&scoped=true"
import script from "./TeleMarketAssignConfig.vue?vue&type=script&lang=js"
export * from "./TeleMarketAssignConfig.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketAssignConfig.vue?vue&type=style&index=0&id=ef5ecd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ecd44",
  null
  
)

export default component.exports